// Live JSON preview of the exact request body a mode is about to POST.
// Lets a research user see the declarative `strategy`/`signals` spec (and
// the wrapping request) before spending compute credit on it.
export default function StrategyPreview({ title = 'Request preview', value }) {
  return (
    <div>
      <h4 className="heading" style={{ fontSize: 13, marginBottom: 6, color: 'var(--text-dim)' }}>
        {title}
      </h4>
      <pre className="aq-json-preview">{JSON.stringify(value, null, 2)}</pre>
    </div>
  );
}
